import { ADD_TO_CART, DECREASE_CART_QTY, INCREASE_CART_QTY, REMOVE_FROM_CART } from "./actionTypes"

export const addToCart = (productId) => {
    return {
        type: ADD_TO_CART,
        payload: productId
    }
}

export const removeFromCart = (productId) => {
    return {
        type: REMOVE_FROM_CART,
        payload: productId
    }
}

export const increaseCartQuantity = (productId) => {
    return {
        type: INCREASE_CART_QTY,
        payload: productId
    }
}

export const decreaseCartQuantity = (productId) => {
    return {
        type: DECREASE_CART_QTY,
        payload: productId
    }
}